// extracted by mini-css-extract-plugin
module.exports = {"cancelEditBtn":"QuickAlertForm_cancelEditBtn__2Q7Y3","targetSvg":"QuickAlertForm_targetSvg__R9ZoQ"};